import { Button } from "@components/ui/button";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import * as Select from "@radix-ui/react-select";
import { useEffect, useState } from "react";
import { addSettings,getUserById ,updateUserById} from "@redux/slices/settings";
import useAuth from "@hooks/useAuth";
import { logout, refreshToken } from "@redux/slices/auth";
import LoadingScreen from "@components/LoadingScreen";
import { useNavigate } from "react-router";
import PATHS from "@routes/paths";
import editIcon from "../../assets/icons/edit-icon.png";
import { supabaseClient } from "@/supabase/app";
import { useDispatch, useSelector } from "@redux/store";
import Registration from "./AddNewUser"

const Settings = () => {
  const [showModal, setShowModal] = useState(false);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(false);
  const { user} = useAuth();
  
  
  const navigate = useNavigate();


  console.log(user?.id)
  console.log("user is juist")


  useEffect(() => {
    if (user) {
      // Place your logic here that needs to run when 'user' is updated
      console.log('User has been updated:', user);
    }
  }, [user]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      
      try {
        const data = await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Ensure loading is set to false even if there is an error
      }
    };
  
    fetchData(); // Call the async function
  }, []);

  const { id, created_at, email, first_name, last_name, company, language, phone_number, photo_url, role } = user;

  console.log(company)
  console.log(first_name)
  console.log(user)

  

const languageLabel = (value : string) => {
  switch (value) {
    case 'eng':
      return 'English';
    case 'ger':
      return 'German';
    default:
      return 'Select Language';
  }
};
const dispatch = useDispatch();


const getUser = async () => {

  console.log("itenkjkj")
  const { data } = await supabaseClient.auth.getUser();
  console.log(data);
  console.log("data fetched si")

  if (data) {
    dispatch(refreshToken());
    console.log("data fetched si"+data)
  } else {
    // dispatch(logout());
    // navigate(PATHS.login);
  }
};

  const getData = async () => {
    const data = await getUserById(user?.id);
    // console.log("Here here")
    // await setSettings(data);
    
    setLoading(false);
    console.log(settings)
    console.log("above")
return data;
  };

  const UploadData = async () => {

    
    await handleChangePassword();
    
    const updatedUser = await updateUserById(id, { 
      email: email,
      first_name: firstName === first_name ? first_name : firstName,
      last_name: emailAddress === last_name ? last_name : emailAddress,
      company: companyName === company ? company : companyName,
      language: selectedLanguage === language ? language : selectedLanguage,
      phone_number: phone_number,
      photo_url:photo_url,
      role:role
    });

    console.log(updatedUser)
    console.log("I am in function")

    getUser()

    if (updatedUser) {
      //  updateUser(useAuth());
      getUser()
      console.log("User updated successfully:", updatedUser);
    } else {
      console.log("Failed to update user.");
    }
    
  };
  
  
 const [firstName, setFirstName] = useState(first_name); // Initialize with existing value or empty string
 const [companyName, setCompanyName] = useState(company); // Initialize with existing value or empty string
 const [emailAddress, setEmailAddress] = useState(last_name); // Initialize with existing value or empty string
 const [password, setPassword] = useState(""); // Initialize with an empty string
 const [selectedLanguage, setSelectedLanguage] = useState<string>(language);

 const handleFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
   setFirstName(e.target.value);
 };

 const handleCompanyNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
   setCompanyName(e.target.value);
 };

 const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
   setEmailAddress(e.target.value);
 };

 const handleLanguageChange = (value: string) => {
  setSelectedLanguage(value);
};

const [Lang, setlang] = useState('');
useEffect(()=>{
  
  setlang(languageLabel(selectedLanguage))
  
},[selectedLanguage])

const [newPassword, setNewPassword] = useState('');



// Password change function
const handleChangePassword = async () => {

  console.log(newPassword)

  const { error } = await supabaseClient.auth.updateUser({
    password: newPassword,
  });

  if (error) {
    console.log(error.message);
    console.log("I am in error")
  } else {
    // setSuccess(true);
    console.log('Password changed successfully');
  }
};


  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div className="h-screen">
          <div className="bg-white relative rounded-lg sm:p-8 p-6">
            <div className="p-10 flex justify-center items-center content-center">
              <div className="bg-white w-full flex">
                <div className="h-[100px] relative w-[100px] rounded-full bg-[#00000033]">
                  <div className="h-[25px] absolute rounded-full bottom-0 w-[25px] right-0">
                    <img src={editIcon} />
                  </div>
                </div>

                <div className="ml-5  flex justify-center items-start flex-col">
                  <div className="font-poppins text-[18.72px] font-medium leading-[28.08px] text-left">
                    {/* {settings?.name} */}
                    {(first_name+" "+emailAddress)}
                  </div>
                  <div className="font-poppins text-[14.98px] font-normal leading-[22.47px] text-left">
                    {email}
                  </div>   
                  <div className="font-poppins text-[14.98px] font-normal leading-[22.47px] text-left">
                    {company}
                  </div>
                </div>
                
              </div>
            </div>

            <div className="pl-10 pt-5 w-[100%]  flex justify-between items-start">
              <div className="bg-white flex-col w-[45%]">
                <div className="pb-2 font-poppins text-[14.98px] font-normal leading-[22.47px] text-left">
                  First Name
                </div>
                <input   onChange={handleFirstNameChange}  placeholder={first_name} className="w-[486px] h-[49px] rounded-[7.49px] p-[10px_15px] gap-[10px] bg-[#F4F4F4]">
                 
                </input>
              </div>

              <div className="bg-white flex-col w-[45%]">
                <div className="pb-2 font-poppins text-[14.98px] font-normal leading-[22.47px] text-left">
                  Last Name
                </div>
                <input   onChange={handleEmailChange}  placeholder={last_name} className="w-[486px] h-[49px] rounded-[7.49px] p-[10px_15px] gap-[10px] bg-[#F4F4F4]"></input>
              </div>

             
            </div>

            <div className="pl-10 pt-5 w-[100%]  flex justify-between items-start">
             

              <div className="bg-white flex-col w-[45%]">
                <div className="pb-2 font-poppins text-[14.98px] font-normal leading-[22.47px] text-left">
                  Company Name
                </div>
                <input   onChange={handleCompanyNameChange} placeholder={company} className="w-[486px] h-[49px] rounded-[7.49px] p-[10px_15px] gap-[10px] bg-[#F4F4F4]"></input>
              </div>

              <div className="bg-white  flex-col w-[45%]">
                <div className="pb-2 font-poppins text-[14.98px] font-normal leading-[22.47px] text-left">
                  Language
                </div>
                <Select.Root
                onValueChange={(value) => handleLanguageChange(value)}
                value={language}>              
                <SelectTrigger
                  // className="SelectTrigger bg-white border-none"
                  className="w-[486px] border-none h-[49px] rounded-[7.49px] p-[10px_15px] gap-[10px] bg-[#F4F4F4]"

                  aria-label="Language"
                >
                  {Lang}
                  {/* <SelectValue placeholder="Select Language" /> */}
                </SelectTrigger>
                <SelectContent className="SelectContent">
                  <SelectItem value="eng">English</SelectItem>
                  <SelectItem value="ger">German</SelectItem>
                </SelectContent>
              </Select.Root>
                
              </div>
            </div>

            <div className="pl-10 pt-5 w-[100%]  flex justify-between items-start">
              <div className="bg-white flex-col w-[45%]">
                <div className="pb-2 font-poppins text-[14.98px] font-normal leading-[22.47px] text-left">
                  Password
                </div>
                <input
                onChange={(e) => setNewPassword(e.target.value)}  value={newPassword}   className="w-[486px] h-[49px] rounded-[7.49px] p-[10px_15px] gap-[10px] bg-[#F4F4F4]"> 
                </input>
              </div>
            </div>


           
{/* 
            {user?.role == "admin" && (
              <Button onClick={() => setShowModal(true)} className="bg-[#1CB5AF] absolute top-10 right-5" >
              Add New User
             </Button>
            )} */}

           
            {/* <Button onClick={() => navigate("../Registration")} className="bg-[#1CB5AF] absolute top-10 right-5">
            Add New User
          </Button> */}


          <Registration
              showModal={showModal}
              handleCloseModal={() => setShowModal(false)}
            />
{/* 
            <Invite
              showModal={showModal}
              handleCloseModal={() => setShowModal(false)}
            /> */}

            <div className="flex justify-end mt-4">
              <Button
                // onClick={() => {
                //   addSettings({
                //     user_id: user?.id,
                //     language: selectedLanguage,
                //   });
                // }}

                onClick={UploadData}
                className="bg-[#1CB5AF]"
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Settings;
